export const mockUsers = [
  { id: '9c37ea41-7584-4fa6-9bc6-bb72137b2bef', name: 'Cynthia Patel', email: 'c.patel@examplecorp.com', role: 'Admin', avatarUrl: 'https://i.pravatar.cc/150?u=a042581f4e29026704d', projects: ['proj_1a', 'proj_1b'] },
  { id: '785ebfe1-97ca-413c-8c68-dee6c4471c94', name: 'Ben Carter', email: 'b.carter@examplecorp.com', role: 'User', avatarUrl: 'https://i.pravatar.cc/150?u=a042581f4e29026702d', projects: ['proj_1a'] },
  { id: 'ed48efd6-64ac-4cd4-9884-78363dd84afc', name: 'Olivia Chen', email: 'o.chen@examplecorp.com', role: 'Reviewer', avatarUrl: 'https://i.pravatar.cc/150?u=a042581f4e29026703d', projects: ['proj_1a', 'proj_1b'] },
];

export const mockOrgs = [
  { id: 'org_1', name: 'Example Corp' },
  { id: 'org_2', name: 'Innovate LLC' }
];

export const mockControlsInitial = {
  'fw_soc2': [
    { id: 'soc2_1', projectControlId: "soc2_1", ref: 'CC1.0', title: 'Control Environment', description: 'The entity demonstrates a commitment to integrity and ethical values...', status: 'Passing' },
    { id: 'soc2_2', ref: 'CC2.0', title: 'Information and Communication', description: 'The entity obtains and uses relevant, quality information to support the functioning of internal control...', status: 'Passing' },
    { id: 'soc2_3', ref: 'CC3.0', title: 'Risk Assessment', description: 'The entity specifies objectives with sufficient clarity to enable the identification and assessment of risks...', status: 'Passing' },
  ],
  'fw_gdpr': [
    { id: 'gdpr_1', ref: 'Article 5', title: 'Principles of processing personal data', description: 'Personal data shall be processed lawfully, fairly and in a transparent manner...', status: 'Passing' },
    { id: 'gdpr_2', ref: 'Article 25', title: 'Data protection by design and default', description: 'The controller shall implement appropriate technical and organisational measures...', status: 'Passing' },
  ],
  'fw_hipaa': [
    { id: 'hipaa_1', ref: '§164.308(a)(1)', title: 'Security Management Process', description: 'Implement policies and procedures to prevent, detect, contain, and correct security violations.', status: 'Passing' },
    { id: 'hipaa_2', ref: '§164.312(b)', title: 'Audit Controls', description: 'Implement hardware, software, and/or procedural mechanisms that record and examine activity...', status: 'Passing' },
  ],
  'fw_custom': [
    { id: 'custom_1', ref: 'LC.1', title: 'Pending Control Example', description: 'This control is awaiting evidence submission.', status: 'Pending' },
    { id: 'custom_2', ref: 'LC.2', title: 'Failed Control Example', description: 'This control has failed its last review and needs new evidence.', status: 'Failed' },
    { id: 'custom_3', ref: 'LC.3', title: 'In Review Control Example', description: 'Evidence for this control has been submitted and is pending review.', status: 'In Review' },
    { id: 'custom_4', ref: 'LC.4', title: 'Not Applicable Control', description: 'This control has been marked as not applicable to this project.', status: 'Not Applicable' },
    { id: 'custom_5', ref: 'LC.5', title: 'Excluded Control', description: 'This control has been formally excluded from this project scope.', status: 'Excluded' },
  ]
};

export const mockGeneratedReports = [
  { id: 'rep_1', name: 'Q3 Progress Report', date: '2025-05-20T10:00:00Z', generatedBy: 'Cynthia Patel' },
  { id: 'rep_2', name: 'SOC 2 Pre-Audit Summary', date: '2025-06-10T14:30:00Z', generatedBy: 'Ben Carter' },
];

export const AVAILABLE_USERS = [
  'Vaibhav Gautam',
  'Vinod Gupta',
  'arpit sir',
  'srwr alam',
  'rajnesh mittal'
];

export const dummyProjects = [
  {
    id: 'PTJ25FO3',
    name: 'Alpha Dashboard',
    description: 'Internal admin panel for monitoring server health.',
    users: [{ initials: 'VG', theme: 'light' }, { initials: 'AS', theme: 'dark' }],
    creator: 'Kunal chang', creatorInitials: 'KC',
    date: '2026-02-20', time: '10:15',
    status: 'Active'
  },
  {
    id: 'PTJ25FO4',
    name: 'Mobile App Redesign',
    description: 'Revamping the UX for the customer-facing iOS app.',
    users: [{ initials: 'VG', theme: 'dark' }, { initials: 'RM', theme: 'light' }, { initials: 'SA', theme: 'dark' }],
    creator: 'Vinod Gupta', creatorInitials: 'VG',
    date: '2026-02-21', time: '09:30',
    status: 'Active'
  },
  {
    id: 'PTJ25FO5',
    name: 'Legacy Migration',
    description: 'Porting COBOL databases to PostgreSQL.',
    users: [{ initials: 'AS', theme: 'light' }],
    creator: 'Arpit Sir', creatorInitials: 'AS',
    date: '2026-02-22', time: '14:20',
    status: 'Inactive'
  },
  {
    id: 'PTJ25FO6',
    name: 'Payment Gateway',
    description: 'Integrating Stripe and PayPal for global markets.',
    users: [{ initials: 'RM', theme: 'dark' }, { initials: 'VG', theme: 'light' }],
    creator: 'Rajnesh Mittal', creatorInitials: 'RM',
    date: '2026-02-23', time: '11:05',
    status: 'Completed'
  },
  {
    id: 'PTJ25FO7',
    name: 'Security Audit',
    description: 'Q1 penetration testing and vulnerability assessment.',
    users: [{ initials: 'SA', theme: 'light' }, { initials: 'AS', theme: 'dark' }],
    creator: 'Srwr Alam', creatorInitials: 'SA',
    date: '2026-02-24', time: '16:45',
    status: 'Active'
  },
  {
    id: 'PTJ25FO8',
    name: 'AI Chatbot v2',
    description: 'Implementing LLM support for customer service.',
    users: [{ initials: 'VG', theme: 'dark' }, { initials: 'RM', theme: 'light' }],
    creator: 'Vaibhav Gautam', creatorInitials: 'VG',
    date: '2026-02-25', time: '08:12',
    status: 'Active'
  }
];

export const dummyFrameworks = [
  {
    "frameworkId": "5f79dd87-1e2a-490c-896f-0758abece20b",
    "name": "SOC 2",
    "description": "System and Organization Controls 2, developed by the AICPA, focusing on security, availability, processing integrity, confidentiality, and privacy."
  },
  {
    "frameworkId": "4e583e2f-8f9d-47c5-8549-beb0ee993aae",
    "name": "GDPR",
    "description": "General Data Protection Regulation for data protection and privacy in the European Union."
  },
  {
    "frameworkId": "a396b917-d2c2-4db2-b64e-8ca876fb89c2",
    "name": "HIPAA",
    "description": "Health Insurance Portability and Accountability Act, which provides data privacy and security provisions for safeguarding medical information."
  }
];

export const availableLanguages = [
  { id: 'English', name: 'English' },
  { id: 'Arbic', name: 'Arbic' },
  { id: 'Spanish', name: 'Spanish' },
  { id: 'French', name: 'French' },
  { id: 'German', name: 'German' },
  { id: 'Portuguese', name: 'Portuguese' },
  { id: 'Chinese', name: 'Chinese' }
];